import Card from '../UI/Card'
import PlantItem from './PlantItem/PlantItem';
import classes from './AvailablePlants.module.css';

const DUMMY_Plants = [
  {
    id: 'p1',
    name: 'Basil',
    description: 'tender plant, used in cuisines ',
    price: 30,
  },
  {
    id: 'p2',
    name: 'Money Plant',
    description: 'brings good luck and prosperity',
    price: 40,
  },
  {
    id: 'p3',
    name: 'Jasmine',
    description: 'strong, sweet fragrance',
    price: 70,
  },
  {
    id: 'p4',
    name: 'Peepal Bonsai',
    description: 'Healthy...and green...',
    price: 400,
  },
];

const AvailablePlants = () => {
  const PlantsList = DUMMY_Plants.map((Plant) => (
    <PlantItem 
      id={Plant.id}
      key={Plant.id}
      name={Plant.name} 
      description={Plant.description} 
      price={Plant.price}
    />
  ));

  return (
    <section className={classes.plants}>
      {PlantsList.map(i=>{
        return(
          <Card>
            <h2>{i}</h2>
          </Card>
        )
      })}
    </section>
  );
};

export default AvailablePlants;